import { createFileRoute } from '@tanstack/react-router'
import KeywordQc from '@/components/smartqc-route/keyword/index.jsx'
import { navigateGuard } from '@/utils/auth.js'
import { UserRole } from '@/constants/user.js'

export const Route = createFileRoute('/_auth/smart-qc/keyword/')({
  beforeLoad: ({ location }) => {
    return navigateGuard(location, [UserRole.ADMINISTRATOR])
  },
  component: KeywordQc,
})
